import { createSlice } from '@reduxjs/toolkit';
import { AnalogInventoryState } from './state';
import { getAnalogInventoryProcessList } from './thunks';


export const initialState: AnalogInventoryState = {
    list: {
        paginate: {
            current_page: 1,
            items: 0,
            last_page: 0,
            pages: 0
        },
        items: []
    },
    loading: false
};
export const analogInventorySlice = createSlice({
    name: 'analog_inventory',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getAnalogInventoryProcessList.fulfilled, (state, action) => {
            state.list = action.payload;
            document.documentElement.scrollTop = 0; // For modern browsers
            document.body.scrollTop = 0; // For older browsers
            state.loading = false;
        });
        builder.addCase(getAnalogInventoryProcessList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getAnalogInventoryProcessList.rejected, (state, action) => {
            state.loading = false;
        });
    }
});

export default analogInventorySlice.reducer;
